'use client';

import { useEffect } from 'react';

import { useConsent } from '@/components/consent/consent-context';
import { captureAttribution } from '@/lib/analytics';

/**
 * Records first-touch campaign attribution once the visitor's consent allows
 * analytics.
 *
 * Mounted globally so it fires on whichever page the visitor actually lands
 * on, not just the ones with a form. Re-runs when consent changes, so someone
 * who accepts the cookie banner on their landing page still gets attributed —
 * `captureAttribution` is idempotent and keeps the first value it stored.
 */
export function AttributionCapture() {
  const { consent, isReady } = useConsent();

  useEffect(() => {
    if (!isReady || !consent.analytics) return;
    captureAttribution();
  }, [isReady, consent.analytics]);

  return null;
}
